// extracted by mini-css-extract-plugin
export var gridWrapper = "index-module--gridWrapper--fcb49";
export var noCertifications = "index-module--noCertifications--80ef1";
export var root = "index-module--root--ef510";